module.exports = __webpack_public_path__ + "static/media/hdi-bumper_selected.dc9e55f1.svg";